import React from 'react';
import produce from 'immer';
import { useField } from '@rocketseat/unform';

import { Text, Modal, Button, TextField } from '@unimed-fesp/components';

import {
  IconSalvar,
  BodyWrapper,
  FooterWrapper,
  ContentWarning,
  ContentWrapper,
  UsuarioWrapper,
  SaveButtonsWrapper,
} from './styles';
import theme from '../../styles/theme';

// #region Componentes
import ModalLiberarAcesso from '../../components/organisms/ModalLiberarAcesso';

import ModalCancelActionFooter from './ModalCancelActionFooter';
import AlertLiberarAcessoModal from './AlertLiberarAcessoModal';
// #endregion

const DadosAcesso = ({
  openModalCancelAction,
  handleCancelarCadastro,
  handleModalCancelAction,
  setUsuarioParams,
  usuarioParams,
  display,
  handleLiberarAcesso,
  handleModalLiberarAcesso,
  openModalLiberarAcesso,
  handleNaoLiberarAcesso,
  isButtonSaveDisabled,
  openModalSuccess,
  handleModalSuccess,
  openModalError,
  handleModalError,
  handleModalLiberarAcessoNewUser,
  handlePreviousTab,
}) => {
  const registerEmail = useField('email').registerField;

  function handleChange(e, status) {
    const newEditarUsuarioParams = produce(usuarioParams, (draft) => {
      if (draft[status] !== e.target.value) draft[status] = e.target.value;

      return draft;
    });

    setUsuarioParams(newEditarUsuarioParams);
  }

  return (
    <ContentWrapper display={display}>
      <BodyWrapper height="270px">
        <UsuarioWrapper>
          <Text
            font="bold 16px/14px Calibri"
            color={theme.greenDefault}
            text="Acesso"
            paddingBottom="20"
          />
          <TextField
            name="nome"
            labelText="Nome"
            marginBottom={30}
            width={623}
            value={usuarioParams.nome}
            disabled
          />
          <TextField
            name="email"
            labelText="E-mail do usuário"
            marginBottom={30}
            width={322}
            value={usuarioParams.email}
            placeholder="Informe o e-mail do usuário"
            font="13px 'Calibri Regular'"
            onChange={(e) => handleChange(e, 'email')}
            register={registerEmail}
          />
        </UsuarioWrapper>
      </BodyWrapper>
      <FooterWrapper>
        <Button
          tipo="tertiary"
          justifyCenter
          alignCenter
          type="button"
          width={100}
          font="16px unimed_slabregular"
          onClick={() => handlePreviousTab('dadosAcesso')}
        >
          voltar
        </Button>
        <SaveButtonsWrapper display="flex">
          <Button
            tipo="secondary"
            marginRight={30}
            paddingTop={1}
            paddingRight={1}
            paddingBottom={1}
            paddingLeft={1}
            padding={1}
            width={191}
            justifyCenter
            alignCenter
            color={isButtonSaveDisabled ? theme.bgWhite : ''}
            background={isButtonSaveDisabled ? theme.grey300 : ''}
            disabled={isButtonSaveDisabled}
            type="button"
            font="16px unimed_slabregular"
            onClick={handleModalLiberarAcessoNewUser}
          >
            salvar e adicionar novo
          </Button>
          <Button
            tipo="primary"
            paddingTop={1}
            paddingRight={1}
            paddingBottom={1}
            paddingLeft={1}
            justifyCenter
            disabled={isButtonSaveDisabled}
            type="button"
            width={100}
            font="16px unimed_slabregular"
            onClick={handleModalLiberarAcesso}
          >
            <IconSalvar />
            salvar
          </Button>
        </SaveButtonsWrapper>
      </FooterWrapper>
      <ModalLiberarAcesso
        onClick={handleModalLiberarAcesso}
        naoLiberarAcesso={handleNaoLiberarAcesso}
        liberarAcesso={handleLiberarAcesso}
        isOpen={openModalLiberarAcesso}
      />
      <Modal
        tipo="warning"
        onClick={handleModalCancelAction}
        isOpen={openModalCancelAction}
        footer={
          <ModalCancelActionFooter
            onClick={handleModalCancelAction}
            onClickOk={handleCancelarCadastro}
          />
        }
      >
        <Text
          center
          text="Ao cancelar o cadastro do usuário, você perderá os dados não salvos. Deseja continuar?"
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
      <Modal
        tipo="success"
        onClick={handleModalSuccess}
        isOpen={openModalSuccess}
        footer={
          <>
            <Button
              tipo="primary"
              marginBottom={30}
              display="block"
              width={100}
              font="16px unimed_slabregular"
              onClick={handleModalSuccess}
            >
              ok
            </Button>
          </>
        }
      >
        <Text
          center
          text="Usuário cadastrado com sucesso."
          font="300 14px work_sans"
          color={theme.titleGray}
        />
        <ContentWarning>
          <AlertLiberarAcessoModal />
        </ContentWarning>
      </Modal>
      <Modal
        tipo="error"
        onClick={handleModalError}
        isOpen={openModalError.error}
        footer={
          <>
            <Button
              tipo="primary"
              marginBottom={30}
              display="block"
              background="#ED1651"
              border="#ED1651"
              type="button"
              width={100}
              font="16px unimed_slabregular"
              onClick={handleModalError}
            >
              ok
            </Button>
          </>
        }
      >
        <Text
          center
          text={openModalError.message || 'Erro ao cadastrar usuário.'}
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
    </ContentWrapper>
  );
};

export default DadosAcesso;
